import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";

const RoutesFilter = ({
  data,
  getData,
  setCurrentRoute,
  currentRoute,
  setPage,
  width,
}) => {
  const [selectedValue, setSelectedValue] = useState(currentRoute);

  useEffect(() => {
    if (selectedValue) {
      getData(1);
      setPage(1);
    } else {
      getData(1);
    }
  }, [selectedValue]);

  return (
    <Autocomplete
      options={data}
      size="small"
      getOptionLabel={(option) => option.route || ""}
      value={data.find((item) => item.route === selectedValue) || null}
      onChange={(event, newValue) => {
        const selectedIndex = newValue ? newValue.route : "";
        setCurrentRoute(selectedIndex);
        setSelectedValue(selectedIndex);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Route"
          variant="outlined"
          style={{
            width: "300px",
            height: "40px",
            marginRight: "10px",
          }}
        />
      )}
    />
  );
};

export default RoutesFilter;
